"use client";

// The clickable half of BlogBuyButton. It is a client island only so the buy
// click goes through the same buyer-survey gate as the Buy on Amazon button on
// the laptop page; the link, price and label are all resolved on the server.

import { useBuyerSurveyGate } from "@/components/buyer-survey-modal";

export function BlogBuyLink({
  url,
  label,
  laptopName,
  laptopSlug,
  country,
}: {
  url: string;
  label: string;
  laptopName: string;
  laptopSlug: string;
  country: string;
}) {
  const { handleBuyClick, gate } = useBuyerSurveyGate({ laptopName, laptopSlug, country });

  return (
    <>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => handleBuyClick(e, { url, retailer: "Amazon" })}
        className="flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-brand text-sm font-semibold text-brand-foreground shadow-sm transition-all hover:opacity-95 active:scale-[0.99]"
      >
        {label}
        <svg viewBox="0 0 16 16" fill="currentColor" className="size-4">
          <path
            fillRule="evenodd"
            d="M4.22 11.78a.75.75 0 0 1 0-1.06L8.94 6H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V7.56l-4.72 4.72a.75.75 0 0 1-1.06 0Z"
            clipRule="evenodd"
          />
        </svg>
      </a>
      {gate}
    </>
  );
}
